export const validTabs = {
  overview: 'overview',
  sales: 'latest-sales',
  downloads: 'latest-downloads',
  monthlySummary: 'monthly-summary',
  payouts: 'payouts',
  coupons: 'coupons',
  discounts: 'discounts',
  donations: 'donations',
  followers: 'followers',
  referrals: 'referrals',
}

export const getSalesTabs = (showOverviewTab, showReferralTab) => [
  ...(showOverviewTab ? [{ id: validTabs.overview, title: 'Overview' }] : []),
  { id: validTabs.payouts, title: 'Payments' },
  { id: validTabs.coupons, title: 'Coupons' },
  { id: validTabs.discounts, title: 'Discounts' },
  { id: validTabs.donations, title: 'Donations' },
  { id: validTabs.followers, title: 'Followers' },
  ...(showReferralTab ? [{ id: validTabs.referrals, title: 'Referrals' }] : []),
]

export const PERIOD_OPTIONS = [
  { value: 1, label: 'Last month' },
  { value: 3, label: 'Last 3 months' },
  { value: 6, label: 'Last 6 months' },
  { value: 12, label: 'Last 12 months' },
  { value: 'all', label: 'Lifetime' },
]

export const donationRates = [
  {
    label: '10%',
    value: '10',
  },
  {
    label: '20%',
    value: '20',
  },
  {
    label: '30%',
    value: '30',
  },
  {
    label: '40%',
    value: '40',
  },
  {
    label: '50%',
    value: '50',
  },
  {
    label: '60%',
    value: '60',
  },
  {
    label: '70%',
    value: '70',
  },
  {
    label: '80%',
    value: '80',
  },
  {
    label: '90%',
    value: '90',
  },
]
